import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { invoices as invoicesApi } from '@/utils/api';
import { CheckCircle2, Loader2 } from 'lucide-react';

export default function PaymentSuccess() {
  const loc = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const p = new URLSearchParams(loc.search);
    const provider = p.get('provider');
    const invoiceId = p.get('invoice_id');
    const sessionId = p.get('session_id');
    const paypalOrder = p.get('token'); // PayPal uses ?token=<order_id>

    async function verify() {
      try {
        if (provider === 'stripe' && sessionId && invoiceId) {
          const r = await invoicesApi.verifyStripe(sessionId, invoiceId);
          if (r.data.status === 'paid') { setStatus('paid'); setMsg('Payment confirmed'); }
          else { setStatus('pending'); setMsg(r.data.status); }
        } else if (provider === 'paypal' && paypalOrder && invoiceId) {
          const r = await invoicesApi.capturePaypal(paypalOrder, invoiceId);
          if (r.data.status === 'paid') { setStatus('paid'); setMsg('Payment confirmed'); }
          else { setStatus('pending'); setMsg(r.data.status || 'pending'); }
        } else {
          setStatus('unknown');
          setMsg('Missing provider / invoice info');
        }
      } catch (e) {
        setStatus('error');
        setMsg(e.response?.data?.detail || 'Verification failed');
      }
    }
    verify();
  }, [loc.search]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--bg)', fontFamily: "'Bricolage Grotesque', sans-serif" }}>
      <div className="max-w-md text-center p-8">
        {status === 'verifying' ? (
          <>
            <Loader2 size={48} className="animate-spin" style={{ color: '#006080', margin: '0 auto 16px' }} />
            <h1 className="text-xl font-black mb-2" style={{ color: 'var(--ink)' }}>Verifying payment…</h1>
          </>
        ) : status === 'paid' ? (
          <>
            <CheckCircle2 size={48} style={{ color: '#3C8A5A', margin: '0 auto 16px' }} />
            <h1 className="text-2xl font-black mb-2" style={{ color: 'var(--ink)' }}>Thank you!</h1>
            <p className="text-sm mb-4" style={{ color: 'var(--muted)' }}>{msg}</p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-bold mb-2" style={{ color: 'var(--ink)' }}>Payment {status}</h1>
            <p className="text-sm mb-4" style={{ color: 'var(--muted)' }}>{msg}</p>
          </>
        )}
        <button className="btn-primary text-xs px-4 py-2" onClick={() => navigate('/portal')} data-testid="back-to-portal">Back to Portal</button>
      </div>
    </div>
  );
}
